/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
    <div class="project-actions-grid">
        <div class="action-card full-width">
            <div class="card-header">
                <h4>Documentación del Proyecto</h4>
                <p class="subtitle">Descarga y gestiona los archivos necesarios</p>
            </div>

            <div class="action-buttons-grid">
                <div class="button-group">
                    <label>Cotizaciones</label>

                    <button class="btn-action primary" @click.prevent="imprimirDesglose">
                        <div class="icon-wrapper pdf-icon">📄</div>
                        <div class="text-wrapper">
                            <span class="btn-title">Cotización técnica</span>
                            <span class="btn-desc">Consumo · ROI · Costos detallados</span>
                        </div>
                        <div class="arrow-icon">⬇</div>
                    </button>

                    <button class="btn-action primary" @click.prevent="imprimirResumen">
                        <div class="icon-wrapper pdf-icon">📄</div>
                        <div class="text-wrapper">
                            <span class="btn-title">Cotización para cliente</span>
                            <span class="btn-desc">Información para el cliente</span>
                        </div>
                        <div class="arrow-icon">⬇</div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BarraAcciones',
    methods: {
        imprimirDesglose() {
            this.$emit('descargar-pdf', 'tecnica');
        },
        imprimirResumen() {
            this.$emit('descargar-pdf', 'cliente');
        }
    }
}
</script>

<style scoped>
.project-actions-grid { width: 100%; font-family: 'Montserrat', sans-serif; }
.action-card { background: #f8fafc; border-radius: 20px; padding: 30px; border: 1px solid #e2e8f0; }
.card-header h4 { margin: 0; font-size: 19px; color: #1e293b; font-weight: 700; }
.subtitle { font-size: 15px; color: #64748b; margin: 6px 0 25px 0; }
.btn-action.primary { width: 100%; display: flex; align-items: center; background: white; border: 1px solid #cbd5e1; padding: 20px; border-radius: 16px; cursor: pointer; transition: all 0.3s; margin-bottom: 12px; }
.btn-action:hover { border-color: #2563eb; transform: translateY(-3px); box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.1); background: #f0f7ff; }
.secondary-outline { width: 100%; display: flex; align-items: center; background: transparent; border: 1px dashed #cbd5e1; padding: 15px; border-radius: 16px; cursor: pointer; margin-top: 10px; }
.icon-wrapper { width: 52px; height: 52px; background: #eff6ff; border-radius: 14px; display: flex; align-items: center; justify-content: center; margin-right: 20px; font-size: 24px; color: #2563eb; }
.text-wrapper { flex: 1; text-align: left; }
.btn-title { display: block; font-weight: 700; color: #1e293b; font-size: 16px; }
.btn-desc { font-size: 13px; color: #64748b; margin-top: 3px; }
.button-group label { display: block; font-size: 12px; text-transform: uppercase; color: #94a3b8; font-weight: 800; margin-bottom: 15px; letter-spacing: 0.8px; }
.arrow-icon { color: #cbd5e1; font-size: 20px; }
</style>